const fivePaid = 'fivePaid';
const sixPaid = 'sixPaid';
const sevenPaid = 'sevenPaid';
const eightPaid = 'eightPaid';
const fiveUnpaid = 'fiveUnpaid';
const sixUnpaid = 'sixUnpaid';
const sevenUnpaid = 'sevenUnpaid';
const eightUnpaid = 'eightUnpaid';
const totalFivePaid = 'totalFivePaid';
const totalSixPaid = 'totalSixPaid' 
const totalSevenPaid = 'totalSevenPaid'; 
const totalEightPaid = 'totalEightPaid'; 
const totalFiveUnpaid = 'totalFiveUnpaid'; 
const totalSixUnpaid ='totalSixUnpaid'; 
const totalSevenUnpaid= 'totalSevenUnpaid'; 
const totalEightUnpaid = 'totalEightUnpaid';
const fivePaidbyCard = 'fivePaidByCard';
const SixPaidbyCard = 'SixPaidByCard'; 
const SevenPaidbyCard = 'sevenPaidByCard'; 
const eightPaidbyCard = 'eightPaidByCard';
const totalPaidByCard = 'totalPaidByCard';   
const intermediate = 'intermediate';
const total = 'total';
const unpaid = 'unpaid';
const forMe = 'forMe';
const otherExpenses = 'otherExpenses';
const leftOver = 'leftOver';
const excessId = 'excessId';
const morningTotalPrice = 'morningTotalPrice';
const morningBackTotalPrice = 'morningBackTotalPrice';
const lunchOneTotalPrice = 'lunchOneTotalPrice';
const lunchOneTeachersTotalPrice = 'lunchOneTeachersTotalPrice';
const lunchOneBackTotalPrice = 'lunchOneBackTotalPrice';
const lunchTwoStudentsTotalPrice = 'lunchTwoStudentsTotalPrice';
const lunchTwoTeachersTotalPrice = 'lunchTwoTeachersTotalPrice';
const lunchTwoBackTotalPrice = 'lunchTwoBackTotalPrice';
const nightTotalPrice = 'nightTotalPrice';
const nightBackTotalPrice = 'nightBackTotalPrice';

export const defaultRows = [
    [
      { value: "ПЪТУВАЩИ", readOnly: true, id: excessId },
      { value: "ПЛАТЕНИ", readOnly: true, id: excessId },
      { value: "ПЛАТЕНИ", readOnly: true, id: excessId }, 
      { value: "ПЛАТЕНИ", readOnly: true , id: excessId }, 
      { value: "ПЛАТЕНИ", readOnly: true, id: excessId }, 
      { value: "НЕПЛАТЕНИ", readOnly: true, id: excessId },
      { value: "НЕПЛАТЕНИ", readOnly: true, id: excessId },  
      { value: "НЕПЛАТЕНИ", readOnly: true, id: excessId },  
      { value: "НЕПЛАТЕНИ", readOnly: true, id: excessId }, 
      { value: "ВСИЧКО", readOnly: true, id: excessId },
    ],
    [
      { value: "ЦЕНА", readOnly: true, id: excessId }, 
      { value: "5.87ЛВ/3.00EUR", readOnly: true, id: excessId }, 
      { value: "6.85ЛВ/3.50EUR", readOnly: true, id: excessId },
      { value: "7.82ЛВ/4.00EUR", readOnly: true, id: excessId },
      { value: "8.80ЛВ/4.50EUR", readOnly: true, id: excessId },
      { value: "5.87ЛВ/3.00EUR", readOnly: true, id: excessId },
      { value: "6.85ЛВ/3.50EUR", readOnly: true, id: excessId }, 
      { value: "7.82ЛВ/4.00EUR", readOnly: true, id: excessId }, 
      { value: "8.80ЛВ/4.50EUR", readOnly: true, id: excessId }, 
      { value: "", readOnly: true, id: excessId }
    ],
    [
      { value: "СУТРИН", readOnly: true }, 
      { value: "", id: fivePaid  }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: morningTotalPrice, readOnly: true }
    ],
    [
      { value: "СУТРИН ВРЪЩАНЕ", readOnly: true }, 
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: morningBackTotalPrice, readOnly: true }
    ],
    [
      { value: "ОБЕД 1", readOnly: true }, 
      { value: "", id: fivePaid  }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchOneTotalPrice, readOnly: true }
    ],
    [
      { value: "ОБЕД 1 УЧИТЕЛИ", readOnly: true }, 
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchOneTeachersTotalPrice, readOnly: true }
    ],
    [
      { value: "ОБЕД 1 ВРЪЩАНЕ", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchOneBackTotalPrice, readOnly: true  }
    ],
    [
      { value: "ОБЕД 2 УЧЕНИЦИ", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchTwoStudentsTotalPrice, readOnly: true }
    ],
    [
      { value: "ОБЕД 2 УЧИТЕЛИ", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchTwoTeachersTotalPrice, readOnly: true }
    ],
    [
      { value: "ОБЕД 2 ВРЪЩАНЕ", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: lunchTwoBackTotalPrice, readOnly: true }
    ],
    [
      { value: "ВЕЧЕР", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: nightTotalPrice, readOnly: true }
    ],
    [
      { value: "ВЕЧЕР ВРЪЩАНЕ", readOnly: true },
      { value: "", id: fivePaid }, 
      { value: "", id: sixPaid }, 
      { value: "", id: sevenPaid }, 
      { value: "", id: eightPaid },
      { value: "", id: fiveUnpaid }, 
      { value: "", id: sixUnpaid }, 
      { value: "", id: sevenUnpaid }, 
      { value: "", id: eightUnpaid }, 
      { value: "", id: nightBackTotalPrice, readOnly: true }
    ],
    [
      { value: "ТЕРМИНАЛ", readOnly: true, id: excessId },
      { value: "", id: fivePaidbyCard }, 
      { value: "", id: SixPaidbyCard },
      { value: "", id: SevenPaidbyCard }, 
      { value: "", id: eightPaidbyCard },
      { value: "", readOnly: true, id: excessId },
      { value: "", readOnly: true, id: excessId }, 
      { value: "", readOnly: true, id: excessId },
      { value: "", readOnly: true, id: excessId }, 
      { value: "", readOnly: true, id: excessId }
    ],
    [
      { value: "МЕЖДИННИ", readOnly: true }, 
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true},
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "" ,id: excessId, readOnly: true}, 
      { value: "", id: intermediate }
    ],
    [
      { value: "ОБЩО", readOnly: true }, 
      { value: "", id: totalFivePaid },
      { value: "", id: totalSixPaid },
      { value: "", id: totalSevenPaid },
      { value: "" , id: totalEightPaid },
      { value: "", id: totalFiveUnpaid },
      { value: "" , id: totalSixUnpaid }, 
      { value: "", id: totalSevenUnpaid },
      { value: "" , id: totalEightUnpaid }, 
      { value: "", id: total }
    ],
    [
      { value: "НЕПЛАТЕНА СУМА", readOnly: true }, 
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true }, 
      { value: "", id: unpaid }
    ],
    [
      { value: "ТЕРМИНАЛ ОБЩО", readOnly: true }, 
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true }, 
      { value: "", id: totalPaidByCard }
    ],
    [
      { value: "ЗА МЕН", readOnly: true }, 
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true},
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true }, 
      { value: "" , id: excessId, readOnly: true},
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: forMe }
    ],
    [
      { value: "ДРУГИ РАЗХОДИ", readOnly: true }, 
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "" , id: excessId, readOnly: true},
      { value: "", id: excessId, readOnly: true }, 
      { value: "" , id: excessId, readOnly: true},
      { value: "", id: excessId, readOnly: true }, 
      { value: "" , id: otherExpenses}
    ],
    [
      { value: "ОСТАВАТ", readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true },
      { value: "", id: excessId, readOnly: true }, 
      { value: "", id: leftOver }
    ],
  ];

export const monthData = [
  { valueName: "Оборот:", value: 0 },
  { valueName: "Гориво:", value: 0 },
  { valueName: "Заплащане:", value: 0 },
  { valueName: "Неплатени:", value: 0 },
  { valueName: "Терминал:", value: 0},
  { valueName: "Чисто:", value: 0 },
];
